export const msalConfig = {
    auth: {
      clientId: "b4c01b29-6031-40ea-b499-c4f04bf60593",
      authority: "https://login.microsoftonline.com/2bb82c64-2eb1-43f7-8862-fdc1d2333b50", // This is a URL (e.g. https://login.microsoftonline.com/{your tenant ID})
      //redirectUri: "http://localhost:3000",
      redirectUri: "https://cws-qa.kone.com"
    },
    cache: {
      cacheLocation: "sessionStorage", // This configures where your cache will be stored
      storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    }
  };
  
  // Add scopes here for ID token to be used at Microsoft identity platform endpoints.
  export const loginRequest = {
   scopes: ["api://44bbe6b0-8d80-4512-b178-0d9c3d5de9c4/Task.Consume"] // "User.Read", 
  };
  
  // Add the endpoints here for Microsoft Graph API services you'd like to use.
  // export const graphConfig = {
  //     graphMeEndpoint: "https://graph.microsoft.com/v1.0/me"
  // };